// Client logo tile — always white background, rounded, prefers real logo image.
import { useState } from "react";
import { Factory } from "lucide-react";

export default function ClientTile({ short, name, image }) {
  const [error, setError] = useState(false);

  if (image && !error) {
    return (
      <div className="h-28 w-52 sm:w-56 bg-white border border-slate-200 rounded-2xl flex items-center justify-center px-4 py-3 hover:border-[#1E3A8A] hover:shadow-md transition-all duration-300">
        <img
          src={image}
          alt={name}
          title={name}
          onError={() => setError(true)}
          className="max-h-16 max-w-full object-contain"
          loading="lazy"
        />
      </div>
    );
  }

  return (
    <div className="h-28 w-52 sm:w-56 bg-white border border-slate-200 rounded-2xl flex items-center justify-center px-3 hover:border-[#1E3A8A] hover:shadow-md transition-all duration-300">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 shrink-0 bg-slate-50 border border-slate-200 rounded-lg flex items-center justify-center">
          <Factory className="w-4 h-4 text-[#1E3A8A]" />
        </div>
        <div className="min-w-0">
          <div className="font-display font-bold text-sm text-slate-800 uppercase tracking-wide truncate">
            {short}
          </div>
          <div className="text-[10px] text-slate-500 truncate max-w-[10rem]">{name}</div>
        </div>
      </div>
    </div>
  );
}
